import HeaderOne from "../header/HeaderOne"
import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import FooterOne from '../footer/FooterOne'
import Breadcrumb from '../components/BreadCurmb'
import BlogSidebar from '../components/BlogSidebar'
import { Link } from "react-router-dom"
export default function News(){
	const [isOpen, setIsOpen] = useState(false);
    const openModal = () => setIsOpen(!isOpen);
	return(
	<>
		<HeaderOne/> 
		<Breadcrumb title="Get In touch" subtitle="Responsive & functional IT blog" pagetitle="News Page"/>
		
		<section className="news-feed-area pt-120 pb-75 pt-md-60 pb-md-15 pt-xs-50 pb-xs-10">
			<div className="container">
				<div className="row mb-15">
				<ModalVideo channel='youtube' isOpen={isOpen} videoId='lTxn2BuqyzU' onClose={() => { openModal(); }} />
					<div className="col-lg-8 pe-xl-0">
						<div className="news-left">
							<div className="blogs blog-4 mb-40">
								<div className="blog__thumb mb-55">
									<Link to="/news-details">
										<img className="img-fluid" src="assets/img/blog/blog-10.jpg" alt="Blog Img" />
									</Link>
									<div className="tag">Business</div>
									<div className="commentor">
										<img src="assets/img/blog/comment-1.jpg" alt="Img" />
										<span>by <b className="text-heding">Hetmayar</b></span>
									</div>
								</div>
								<div className="blog-content">
									<h3><Link className="blog-title4" to="/news-details">Both the act of teaching
											knowledge to others and
											the act of kind of design thinking.</Link></h3>
									<p className="mb-20">Novia's spaciously two bedroom apartments are perfect for families
										and even business partners. Look out into the Manhattan skyline from the open
										fully equipped kitchen.
									</p>
									<div className="blogs__meta">
										<span><i className="fal fa-eye"></i> 100 Views</span>
										<span className="border-line2"><i className="fal fa-comments"></i> 30 Comments</span>
										<span><i className="fal fa-calendar-alt"></i> 24th March 2022</span>
									</div>
								</div>
							</div>
							<div className="blogs blog-4 mb-40">
								<div className="blog__thumb mb-55">
									<Link to="/news-details">
										<img className="img-fluid" src="assets/img/blog/blog-11.jpg" alt="Blog Img" />
									</Link>
									<div className="tag">Business</div>
									<div className="commentor">
										<img src="assets/img/blog/comment-1.jpg" alt="Img" />
										<span>by <b>Hetmayar</b></span>
									</div>
									<a className="popup-video" onClick={() => { openModal(); }}><i className="fa fa-play"></i></a>
								</div>
								<div className="blog-content">
									<h3><Link className="blog-title4" to="/news-details">Both the act of teaching
											knowledge to others and
											the act of kind of design thinking.</Link></h3>
									<p>Novia's spaciously two bedroom apartments are perfect for families and even
										business partners. Look out into the Manhattan skyline from the open fully
										equipped kitchen.</p>
									<div className="blogs__meta">
										<span><i className="fal fa-eye"></i> 100 Views</span>
										<span className="border-line2"><i className="fal fa-comments"></i> 30 Comments</span>
										<span><i className="fal fa-calendar-alt"></i> 24th March 2022</span>
									</div>
								</div>
							</div>
							<div className="blogs blog-4 mb-40">
								<div className="blog-img-active owl-carousel">
									<div className="item">
										<div className="blog__thumb mb-55">
											<Link to="/news-details">
												<img className="img-fluid" src="assets/img/blog/blog-10.jpg" alt="Blog Img" />
											</Link>
											<div className="tag">Business</div>
											<div className="commentor">
												<img src="assets/img/blog/comment-1.jpg" alt="Img" />
												<span>by <b>Hetmayar</b></span>
											</div>
										</div>
									</div>
									<div className="item">
										<div className="blog__thumb mb-55">
											<Link to="/news-details">
												<img className="img-fluid" src="assets/img/blog/blog-11.jpg" alt="Blog Img" />
											</Link>
											<div className="tag">Business</div>
											<div className="commentor">
												<img src="assets/img/blog/comment-1.jpg" alt="Img" />
												<span>by <b>Hetmayar</b></span>
											</div>
										</div>
									</div>
									<div className="item">
										<div className="blog__thumb mb-55">
											<Link to="/news-details">
												<img className="img-fluid" src="assets/img/blog/blog-12.jpg" alt="Blog Img" />
											</Link>
											<div className="tag">Business</div>
											<div className="commentor">
												<img src="assets/img/blog/comment-1.jpg" alt="Img"/>
												<span>by <b>Hetmayar</b></span>
											</div>
										</div>
									</div>
								</div>
								<div className="blog-content">
									<h3><Link className="blog-title4" to="/news-details">Both the act of teaching
											knowledge to others and
											the act of kind of design thinking.</Link></h3>
									<p>Novia's spaciously two bedroom apartments are perfect for families and even
										business partners. Look out into the Manhattan skyline from the open fully
										equipped kitchen.</p>
									<div className="blogs__meta">
										<span><i className="fal fa-eye"></i> 100 Views</span>
										<span className="border-line2"><i className="fal fa-comments"></i> 30 Comments</span>
										<span><i className="fal fa-calendar-alt"></i> 24th March 2022</span>
									</div>
								</div>
							</div>
							<div className="blogs blog-4 mb-40">
								<div className="blog__thumb mb-40">
									<Link to="/news-details">
										<img className="img-fluid" src="assets/img/blog/blog-13.jpg" alt="Blog Img" />
									</Link>
								</div>
								<div className="blog-content">
									<h3><Link className="blog-title4" to="/news-details">Both the act of teaching
											knowledge to others and
											the act of kind of design thinking.</Link></h3>
									<p>Novia's spaciously two bedroom apartments are perfect for families and even
										business partners. Look out into the Manhattan skyline from the open fully
										equipped kitchen.</p>
									<div className="blogs__meta">
										<span><i className="fal fa-eye"></i> 100 Views</span>
										<span className="border-line2"><i className="fal fa-comments"></i> 30 Comments</span>
										<span><i className="fal fa-calendar-alt"></i> 24th March 2022</span>
									</div>
								</div>
							</div>
							<div className="blogs blog-4 mb-40">
								<div className="blog-content mt-40">
									<h3><Link className="blog-title4" to="/news-details">Both the act of teaching
											knowledge to others and
											the act of kind of design thinking.</Link></h3>
									<p>Novia's spaciously two bedroom apartments are perfect for families and even
										business partners. Look out into the Manhattan skyline from the open fully
										equipped kitchen.</p>
									<div className="blogs__meta">
										<span><i className="fal fa-eye"></i> 100 Views</span>
										<span className="border-line2"><i className="fal fa-comments"></i> 30 Comments</span>
										<span><i className="fal fa-calendar-alt"></i> 24th March 2022</span>
									</div>
								</div>
							</div>
							<div className="grey-bg quote-box mb-35">
								<img className="quote-icon" src="assets/img/blog/quote-small-1.png" alt="Icon" />
								<h3><Link className="blog-title4" to="/news-details">The act of teaching knowledge to
										others & the act of kind of design thinking.</Link>
								</h3>
							</div>
						</div>
					</div>
					<div className="col-lg-4 pl-30 pl-lg-15 pl-md-15 pl-xs-15">
					<BlogSidebar/>
					</div>
				</div>
				<div className="row justify-content-center mb-30">
					<div className="col-lg-8">
						<div className="page-navigation">
							<ul className="pagination">
								<li className="page-item"><Link className="page-link" to="#"><i
											className="fal fa-chevron-double-left"></i></Link></li>
								<li className="page-item"><Link className="page-link" to="#">01</Link></li>
								<li className="page-item"><Link className="page-link" to="#">02</Link></li>
								<li className="page-item"><Link className="page-link" to="#">03</Link></li>
								<li className="page-item"><Link className="page-link" to="#"><i
											className="fal fa-ellipsis-h"></i></Link></li>
								<li className="page-item"><Link className="page-link" to="#">10</Link></li>
								<li className="page-item"><Link className="page-link" to="#"><i
											className="fal fa-chevron-double-right"></i></Link></li>

							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
		<FooterOne />
	</>
	)
}
	
	

